import { ComponentCanDeactivate } from '../../guards/component-can-deactivate';
import { FormGroup } from '@angular/forms';

export class FormCanDeactivate extends ComponentCanDeactivate {
  saved: boolean;
  form: FormGroup;
  submit = () => (this.saved = true);
  canDeactivate = () => this.saved || !this.form.dirty;
}
